var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.255,
    height: 13.261,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48196",
    d: "M11.761 10.818c.428.42.856.824 1.265 1.247a.667.667 0 0 1-.04 1.039.852.852 0 0 1-.459.145c-2.054.009-4.109.022-6.163 0a6.627 6.627 0 1 1 5.4-2.434M2.638 6.591A3.954 3.954 0 1 0 6.6 2.642a3.954 3.954 0 0 0-3.962 3.949",
    fill: "#185edf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoraIcon);
export default __webpack_public_path__ + "static/media/Quora_Icon.2a7c7bb7ae1fc4f9a88176dbdb908f51.svg";
export { ForwardRef as ReactComponent };